import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";
import { GameType } from "../Data/GameData";
import * as VoiceOver from "../Data/VoiceOver";
import { GalleryItem } from "../GameObjects/GalleryItem";
import { GalleryPaintable } from "../GameObjects/GalleryPaintable";
import { PaintableMask } from "../GameObjects/PaintableMask";

export class GalleryMask extends GalleryPaintable {
    constructor(pCallback: (pItem: GalleryItem) => void) {
        super(GameType.MASK, pCallback);

        this._homePos = new PIXI.Point(0, -200);
        this._homeScale = 0.3525;
        this._presentScale = 0.675;
        this._targetState = Constants.STATE_MASK;
        this._hoverVO = VoiceOver.MASK_BUTTON;

        this.createVisuals();
    }

    protected createVisualDefault(): void {
        // because mask is onboarding, we never actually see this sprite
        const image: PIXI.Sprite = HLF.PixiUtils.makeSprite("menu-button-dress", Constants.SPRITESHEET_MENU);
        this._visuals.addChild(image);

        this._visuals.position.copy(this._homePos);
    }

    protected createVisualComplete(): void {
        this._paintable = new PaintableMask(this.recentIndex, false);
        this._visuals.addChild(this._paintable);

        this._visuals.position.set(-this._size.x * 0.5 - this._paintable.width * 0.5, -100);
    }

    protected createVisualCached(): void {
        super.createVisualCached();
        this._cached!.scale.set(this._homeScale);
    }
}
